import { Dispatch, SetStateAction, useState } from 'react';
import { use_effect } from './use_effect';

export function use_state_updating<T>(value: T): [T, Dispatch<SetStateAction<T>>] {
  const [value_state, set_value_state] = useState<T>(value);

  /*
   * EFFECTS
   */
  use_effect(() => void set_value_state(value), [value]);

  return [value_state, set_value_state];
}
